import React, { useEffect, useState } from 'react';
import { Avatar, IconButton, Menu, MenuItem } from '@mui/material';
import { useMsal } from '@azure/msal-react';
import LogoutIcon from '@mui/icons-material/Logout';
import axios from 'axios';
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';
import { useNavigate } from 'react-router-dom';

import useGetUserRoleFlags from '../hooks/useGetUserRoleFlags';
import { headerTokens } from '../theme/appTheme';


const UserAvatar = () => {
    const { instance, accounts } = useMsal();
    const account = accounts[0];

    const fullName = account?.name || 'Unbekannter Benutzer';
    const initials = fullName
        .split(' ')
        .reverse() // Reihenfolge umdrehen: Vorname zuerst
        .map((n) => n[0])
        .join('')
        .toUpperCase();


    const [photoUrl, setPhotoUrl] = useState<string | null>(null);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const { highestRole, isCreator, isAdmin } = useGetUserRoleFlags();
    const navigate = useNavigate();

    useEffect(() => {
        const fetchPhoto = async () => {
            try {
                const response = await instance.acquireTokenSilent({
                    scopes: ['User.Read'],
                    account: account,
                });

                const photoResponse = await axios.get(
                    'https://graph.microsoft.com/v1.0/me/photo/$value',
                    {
                        headers: {
                            Authorization: `Bearer ${response.accessToken}`,
                        },
                        responseType: 'blob',
                    }
                );

                const imageUrl = URL.createObjectURL(photoResponse.data);
                setPhotoUrl(imageUrl);
            } catch (error) {
                console.log('Kein Profilbild gefunden oder Zugriff verweigert.');
            }
        };

        fetchPhoto();
    }, [account, instance]);

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleLogout = () => {
        instance.logoutRedirect({ postLogoutRedirectUri: '/' });
        handleClose();
    };

    const handleOpenWorkspace = () => {
        navigate('/my-workspace');
        handleClose();
    };

    return (
        <>
            {/* Sized to headerTokens.controlSize so the avatar, the theme button and the
                42px logo all sit on one 42px header row, as in VehicleDebugger. */}
            <IconButton onClick={handleClick} sx={{ p: 0, flexShrink: 0 }}>
                <Avatar
                    src={photoUrl || undefined}
                    sx={{ width: headerTokens.controlSize, height: headerTokens.controlSize, fontSize: '0.8rem' }}
                >
                    {!photoUrl && initials}
                </Avatar>
            </IconButton>
            <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
                <MenuItem disabled>{fullName}</MenuItem>
                <MenuItem disabled>{highestRole}</MenuItem>
                {(isCreator || isAdmin) && (
                    <MenuItem onClick={handleOpenWorkspace}>
                        <WorkOutlineIcon fontSize="small" style={{ marginRight: 8 }} />
                        My Workspace
                    </MenuItem>
                )}
                <MenuItem onClick={handleLogout}>
                    <LogoutIcon fontSize="small" style={{ marginRight: 8 }} />
                    Logout
                </MenuItem>
            </Menu>
        </>
    );
};

export default UserAvatar;